var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMageVideoPlayer1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01831 7.43719H19.6481M14.9287 7.43719V2.71875M7.7377 7.43719V2.71875M9.57653 11.2669V15.9155C9.57653 16.0109 9.60676 16.1044 9.66248 16.1856C9.71914 16.2659 9.79942 16.331 9.89481 16.3735C9.99094 16.4156 10.0961 16.4327 10.2006 16.4233C10.3051 16.4139 10.4056 16.3783 10.4926 16.3197L14.0796 13.8169C14.1493 13.7685 14.2063 13.704 14.2459 13.629C14.2831 13.5565 14.3009 13.4756 14.2976 13.3942C14.2943 13.3127 14.27 13.2335 14.227 13.1643C14.1805 13.0929 14.1185 13.0328 14.0456 12.9886L10.4586 10.8429C10.3709 10.7919 10.2721 10.7631 10.1707 10.759C10.0693 10.7548 9.96844 10.7755 9.87687 10.8193C9.78894 10.8617 9.71346 10.9261 9.65775 11.0063C9.6056 11.0832 9.57735 11.1739 9.57653 11.2669Z",
    stroke: "#19607E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4027 2.59766H8.26383C5.13422 2.59766 2.59717 5.13471 2.59717 8.26432V14.4032C2.59717 17.5328 5.13422 20.0699 8.26383 20.0699H14.4027C17.5323 20.0699 20.0694 17.5328 20.0694 14.4032V8.26432C20.0694 5.13471 17.5323 2.59766 14.4027 2.59766Z",
    stroke: "#19607E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageVideoPlayer1);
export default __webpack_public_path__ + "static/media/mage_video-player-1.376bdfb31850e7094a706b8e42ae53b5.svg";
export { ForwardRef as ReactComponent };